module.exports = {
          srcSet: __webpack_public_path__ + "65c0332c1496f00ccf427d71b41a1d56-30.png"+" 30w",
          images:[ {path: __webpack_public_path__ + "65c0332c1496f00ccf427d71b41a1d56-30.png",width: 30,height: 30}],
          src: __webpack_public_path__ + "65c0332c1496f00ccf427d71b41a1d56-30.png",
          toString:function(){return __webpack_public_path__ + "65c0332c1496f00ccf427d71b41a1d56-30.png"},
          
          width: 30,
          height: 30
        }